import React, { Component } from 'react'
import { getGuestInRoom, setDeviceLoginPage, popupOpenClose, setLoadingMass, setFailScreen } from '../../action/action'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { guestBillDetails, setDefaultBill, getServiceID, guestHistroy } from '../../action/viewBillAction'
import ShowBill from './ShowBill'
import { viewBIllColorConfig } from '../../JS/setColors'
import { setGoHome } from '../../layout2.0/action/homeAction';

class ViewBill extends Component {

    constructor(props) {
        super(props);
        this.state = {
            checkInDate: "DD/MM/YYYY",
            selectedGuest: {},
            SessionToken: localStorage.getItem('GuestJourneySessionToken')
        }
    }

    componentWillUnmount() {
        this.props.setDefaultBill();
    }
    componentDidMount() {
        let SessionToken = localStorage.getItem("GuestJourneySessionToken");
        let room = localStorage.getItem("room")
        if (this.props.CheckedInGuest.length === 0) {
            this.props.getGuestInRoom(this.props.guestDetails, this.guestListCallBack);
        } if (SessionToken && (!this.props.guestDetails.locationId || !this.props.guestDetails.guestToken)) {
            console.log("view Bill widget: no session token");
            if (this.props.currentWidget.widgetType && !room || room === "null") {
                this.props.setDeviceLoginPage(true);
                console.log("room", room);
            } else {
                console.log("there is some bug in guest registration flow.")
            }
        }
        if (SessionToken) {
            this.props.getServiceID(SessionToken, (status, msg)=>{
                if(!status){
                this.props.setFailScreen(true, msg, "", true)
                this.props.setGoHome(true);
                }
            });
        }
        if (this.props.CheckedInGuest.length === 1) {
            console.log("comparing object works");
            this.props.guestHistroy(this.props.CheckedInGuest[0], this.guestHisCallBack);
            this.props.setLoadingMass(true);
        }
        viewBIllColorConfig(this.props.menuColor);
    }

    componentDidUpdate(prevProps) {
        console.log("componentDidUpdate");
        if (prevProps.CheckedInGuest !== this.props.CheckedInGuest &&
            this.props.CheckedInGuest.length === 1) {
            console.log("comparing object works");
            this.props.guestHistroy(this.props.CheckedInGuest[0], this.guestHisCallBack);
            this.props.setLoadingMass(true);
        }
    }

    guestHisCallBack = (status, errorMSG) => {
        if (status) {
            if (this.props.CheckedInGuest.length === 1) {
                this.props.guestBillDetails(this.props.CheckedInGuest[0]);
                this.props.setLoadingMass(false);
            } else {
                this.props.guestBillDetails(this.state.selectedGuest);
                this.props.setLoadingMass(false);
            }
        } else {
            this.props.setLoadingMass(false);
            this.props.popupOpenClose(true, "Guest is not checked in.");
        }
    }

    guestSelected = () => {
        let date;
        let guestID = document.getElementById("viewBillGuestSelectList").value;
        if (guestID === "0" || guestID === null) {
            console.log("no guest selected");
        } else {
            this.props.CheckedInGuest.map((iterator) => {
                if (`${iterator.id}` === guestID) {
                    date = new Date(iterator.checkInDate);
                    console.log("date",
                        `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`);
                    date = `${date.getDate() < 10 ?
                        `0${date.getDate()}` : date.getDate()
                        }/${date.getMonth() + 1 < 10 ?
                            `0${date.getMonth() + 1}` : date.getMonth() + 1
                        }/${date.getFullYear()}`
                    this.setState({
                        selectedGuest: iterator,
                        checkInDate: date
                    })
                }
            })
        }
    }

    getBill = () => {
        this.props.setLoadingMass(true);
        this.props.guestHistroy(this.state.selectedGuest, this.guestHisCallBack);
        //this.props.guestBillDetails(this.state.selectedGuest);
    }

    render() {
        //let date = new Date();
        return (
            <div id="ico-view-bill" className="contentSection columns h-100 center-v">
                <div className="col col-2 h-100 m-r25"
                    style={{ background: "rgba(255,255,255,0.9)", marginRight: 0, padding: "1rem", color: "inherit" }}>
                    <div style={{ color: "inherit" }} className="activity-heading all-caps">{this.props.displayName}</div>
                    <div className="form-item" style={{ color: "inherit" }}>
                        <label style={{ color: "inherit" }}>Select a guest</label>
                        <select id="viewBillGuestSelectList" name="guest-list" onClick={this.guestSelected}>
                            <option
                                value={
                                    this.props.CheckedInGuest.length === 1 ?
                                        this.props.CheckedInGuest[0].id : 0
                                }
                            >
                                {
                                    this.props.CheckedInGuest.length === 1 ?
                                        this.props.CheckedInGuest[0].guestName : "select guest"
                                }
                                {
                                    // this.props.CheckedInGuest.length === 1 &&
                                    //     !this.state.selectedGuest.guestToken ?
                                    //     this.guestSelected() : null
                                }
                            </option>
                            {
                                this.props.CheckedInGuest.length > 0 && this.props.CheckedInGuest.length !== 1 ?
                                    this.props.CheckedInGuest.map((iterator) => {
                                        return (
                                            <option value={iterator.id}>{iterator.guestName}</option>
                                        )
                                    }) : null
                            }
                        </select>
                    </div>
                    {/* <div className="form-item" style={{ color: "inherit" }}>
                        <label style={{ color: "inherit" }}>Check in date</label>
                        <input id="viewMyBillCheckInDate" name="checkin-date" value={this.state.checkInDate} readonly />
                    </div> */}
                    <div className="center">
                        {/* <div className="err-msg">Insert error message here</div>
                        <div className="success-msg">Insert success message here</div> */}
                        <button id="viewBillButton" className="button w-100" onClick={this.getBill}>View bill</button>
                    </div>
                </div>
                {
                    this.props.billItems.length > 0 ?
                        <ShowBill
                            selectedGuest={
                                this.props.CheckedInGuest.length === 1 ?
                                    this.props.CheckedInGuest[0] : this.state.selectedGuest
                            }
                            checkInDate={this.state.checkInDate} />
                        :
                        <div id="vb-list" className="col col-2 h-100 results-col"
                            style={{ background: "rgba(204,204,204,0.95)", padding: "1rem" }}>
                            {this.props.billForGuest ?
                                <div classNameName="err-msg">
                                    No Bill available for this Guest.
                                </div>
                                :
                                <div classNameName="err-msg" style={{ color: "inherit" }}>
                                    Please select the Guest Name to see the Bill.
                                </div>
                            }
                        </div>
                }
            </div >
        )
    }
}



const mapStateToProps = state => {
    return {
        guestDetails: state.store.home.guestDetails,
        CheckedInGuest: state.store.CheckedInGuest,
        currentWidget: state.store.sideNavBar.currentWidget,
        billItems: state.store.viewBill.billItems,
        billForGuest: state.store.viewBill.billForGuest,
        menuColor: state.store.home.MenuColor,
        extendStayID: state.store.viewBill.extendStayID,
        displayName: state.store.sideNavBar.currentWidget.displayName
    }
}

export default connect(
    mapStateToProps,
    {
        getGuestInRoom,
        setDeviceLoginPage,
        guestBillDetails,
        setDefaultBill,
        getServiceID,
        guestHistroy,
        popupOpenClose,
        setLoadingMass,
        setFailScreen,
        setGoHome
    }
)(ViewBill);

